export default __webpack_public_path__ + "static/media/recruit.70fae5d9.svg";